export default __webpack_public_path__ + "static/media/Raleway-Medium.740cd847.woff";